import { createContext } from "react";

const noticeContext = createContext();

export default noticeContext;